module.exports = __webpack_public_path__ + "img/shortcuts-app.d230a25c.png";